export const validateEmail = (email: string) => {
  const emailRegex = new RegExp(
      /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
      'gm',
  ),
  companyMatch = new RegExp(
      /^[a-zA-Z0-9._%+-]+@(?!gmail.com)(?!yahoo.com)(?!yahoo.co.in)(?!aol.com)(?!hotmail.com)(?!live.com)(?!outlook.com)(?!mail.com)(?!test.com)(?!example.com)(?!example.net)[a-zA-Z0-9_-]+.[a-zA-Z0-9-.]{2,61}$/,
  );

  return emailRegex.test(email) && companyMatch.test(email);
}



export const validateMaxChar = (input: string, maxChar = 300) =>  {
  const charCount = input.length;

  return { isValid: charCount <= maxChar, charCount, isLimitReached: charCount >= maxChar };
}
